import * as Yup from 'yup';
import { LegalProceedingProcessData } from '../../../../../../shared/types/legalProceedings/legalProceedings';

export const initialValues: LegalProceedingProcessData = {
    dateReceipt: '',
    registeredCompany: '',
    documentClaimant: '',
    nameClaimant: '',
    documentProcessed: '',
    nameProcessed: '',
    insuredDocument: '',
    insuredName: '',
    requirementNumber: '',
    fileNumber: '',
    namePersonSubscribe: '',
    policy: '',
    senderEmail: '',
    plate: '',
    expirationDate: '',
    legalProceedings: '',
    pqrIdentified: '',
    submittingEntity: '',
    address: '',
    status: '',
    subject: '',
    location: '',
    detail: '',
};

export const validationSchema = Yup.object({
    dateReceipt: Yup.string().required('La fecha de recepción es obligatoria'),
    registeredCompany: Yup.string(),
    documentClaimant: Yup.string().required(
        'El documento del accionante obligatorio'
    ),
    nameClaimant: Yup.string().required(
        'El nombre del accionante es obligatorio'
    ),
    requirementNumber: Yup.string()
        .required('El número del requerimiento es obligatorio')
        .matches(
            /^\d+$/,
            'El número del requerimiento debe ser numérico y no debe contener espacios ni caracteres especiales'
        ),
    fileNumber: Yup.string()
        .required('El número de expediente es obligatorio')
        .matches(
            /^\d+$/,
            'El número de expediente debe ser numérico y no debe contener espacios ni caracteres especiales'
        ),
    namePersonSubscribe: Yup.string().required(
        'El nombre de la persona que subscribe es obligatorio'
    ),
    policy: Yup.string(),
    senderEmail: Yup.string()
        .email('El correo es inválido')
        .required('El correo es obligatorio')
        .test('Validate Email', 'El correo es inválido', (value) => {
            const re =
                /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(String(value).toLowerCase());
        }),
    legalProceedings: Yup.string().required(
        'El proceso judicial es obligatorio'
    ),
    submittingEntity: Yup.string().required(
        'La entidad remitente es obligatoria'
    ),
    status: Yup.string().required('El estado es obligatorio'),
    subject: Yup.string().required('El asunto es obligatorio'),
    location: Yup.string().required('La ubicación es obligatoria'),
});
